import { render, staticRenderFns } from "./EnergyProvidersAdd.vue?vue&type=template&id=4b61716d&"
import script from "./EnergyProvidersAdd.vue?vue&type=script&lang=js&"
export * from "./EnergyProvidersAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports